// extracted by mini-css-extract-plugin
export default {"content":"NewsItemPage_content__bzYBd"};